import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './cadastroPJ.scss';
import useFetch from '../../../components/hooks/useFetch';
import useAlerta from '../../../components/hooks/useAlerta';
import { CADASTRAR_MEUCORREIOS_PJ } from '../../../services/cadastro';
import FormCadastroPJ from './FormCadastroPJ';
import FormCadastroPJEstrangeiroComCnpj from './FormCadastroPJEstrangeiroComCnpj';
import FormCadastroPJEstrangeiroComAn8 from './FormCadastroPJEstrangeiroComAn8';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/form/Input';

const CadastroPJ = () => {
  const { t } = useTranslation();
  const [nacionalidade, setNacionalidade] = React.useState('0');
  const [orientacaoCadastro, setOrientacaoCadastro] = React.useState(true);
  const { request } = useFetch();

  const handleNacionalidade = (event) => {
    setNacionalidade(event.target.value);
    if (event.target.value === '0') {
      setOrientacaoCadastro(true);
    } else if (event.target.value === '1') {
      setOrientacaoCadastro(true);
    } else if (event.target.value === '2') {
      setOrientacaoCadastro(false);
    }
  };

  const { abreAlerta } = useAlerta();
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };

    fetchIPAddress();
  }, []);

  const incluirLogin = async (data) => {
    const { response } = await request(
      CADASTRAR_MEUCORREIOS_PJ(data, ipAddress),
    );
    if (response.ok) {
      const meioEnvioTelefone = data.foneMovel;
      const meioEnvioEmail = data.email;
      const meioEnvio = data.meioEnvio;
      const idCorreios = data.idCorreios;
      navigate('/finalizaCadastroToken', {
        state: { meioEnvio, meioEnvioEmail, meioEnvioTelefone, idCorreios },
      });
    }
  };

  return (
    <>
      <div className="conteudo">
        <div id="cadastro-pj" className="card bg-superficie elev5">
          <img
            alt={t('cadastro.accessibility.carol_image')}
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h2>{t('cadastro.titles.business')}</h2>

          <div className="controle nacionalidade">
            <label className="radio">
              <Input
                type="radio"
                id="nacional"
                name="nacionalidade"
                value="0"
                checked={nacionalidade === '0'}
                onChange={handleNacionalidade}
              />
              <div className="subtitulo-p">{t('cadastro.forms.options.national')}</div>
            </label>

            <label className="radio">
              <input
                type="radio"
                id="estrangeiro"
                name="nacionalidade"
                value="1"
                checked={nacionalidade === '1'}
                onChange={handleNacionalidade}
              />
              <div className="subtitulo-p">{t('cadastro.forms.options.foreign_with_cnpj')}</div>
            </label>

            <label className="radio">
              <input
                type="radio"
                id="estrangeiroComAN8"
                name="nacionalidade"
                value="2"
                checked={nacionalidade === '2'}
                onChange={handleNacionalidade}
              />
              <div className="subtitulo-p">{t('cadastro.forms.options.foreign_with_an8')}</div>
            </label>
          </div>

          {orientacaoCadastro && (
            <p className="justificado">
              {t('cadastro.messages.info.cnpj_explanation')}
              &ensp;
              <a
                href="https://cav.receita.fazenda.gov.br/autenticacao/login"
                target="_blank"
                rel="noopener noreferrer"
                className="link-grande"
              >
                cav.receita.fazenda.gov.br/autenticacao/login
              </a>
            </p>
          )}

          {nacionalidade === '0' ? (
            <FormCadastroPJ onSubmit={incluirLogin} />
          ) : nacionalidade === '1' ? (
            <FormCadastroPJEstrangeiroComCnpj onSubmit={incluirLogin} />
          ) : (
            <FormCadastroPJEstrangeiroComAn8 onSubmit={incluirLogin} />
          )}
        </div>
      </div>
    </>
  );
};

export default CadastroPJ;
